export function FancyNameReducer(state = '', action) {
    switch (action.type) {
        case "SET_FANCY_NAME":
            return action.payload;
        default:
            return state;
    }
}

export function FancyCRTReducer(state = '', action) {
    switch (action.type) {
        case "SET_CRT":
            return action.payload;
        default:
            return state;
    }
}

export function cnaeReducer(state = null, action) {
    switch (action.type) {
        case "SET_CNAE":
            return action.payload;
        default:
            return state;
    }
}

export function stateRegistryReducer(state = '', action) {
    switch (action.type) {
        case "SET_STATE_REGISTRY":
            return action.payload;
        default:
            return state;
    }
}


export function ieIndicatorReducer(state = null, action) {
    switch (action.type) {
        case "SET_IE_INDICATOR": {
            const v = action.payload;
            if (v === null || v === undefined || v === "") return null;
            const n = typeof v === "number" ? v : parseInt(v, 10);
            return [1, 2, 9].includes(n) ? n : state; 
        }
        default:
            return state;
    }
}


export function municipalRegistryReducer(state = '', action) {
    switch (action.type) {
        case "SET_MUNICIPAL_REGISTRY":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/parts/company-data/reducers.js